import dayjs from 'dayjs';

export const startOfDay = (date: Date): Date => dayjs(date).startOf('day').toDate();
export const endOfDay = (date: Date): Date => dayjs(date).endOf('day').toDate();
